import { useState } from 'react'
import { useSelector } from 'react-redux'
import { APISERVICE } from '../services/api.service'
import { toast } from 'react-toastify'

export function useTicket() {
    const [loading, setLoading] = useState(false)
    const scheduleStorage = useSelector((store) => store.teacher.infoSchedule)
    const teacherInfo = useSelector((store) => store.teacher.teacherInfo)
    const sendTicket = async (tickeo, type, id = []) => {
        try {
            setLoading(true)
            const url = 'verificacion/update-verification?'
            const { success, message } = await APISERVICE.post(url, '', { id })
            if (success && tickeo) {
                toast.success(message)
            } else if (tickeo) {
                toast.error(message)
            }
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    const sendEndClass = async ({ descripcion, file, tickeo, actividades, recursos_educativos }) => {
        let endClassInfo = null
        try {
            setLoading(true)
            const formData = new FormData()
            const url = 'verificacion/end-class'
            formData.append('docenteId', teacherInfo.teacherId)
            formData.append('horarioId', scheduleStorage.schedule.id)
            formData.append('descripcion', descripcion)
            if (actividades?.length || recursos_educativos?.length) {
                formData.append(
                    'payload',
                    JSON.stringify({
                        actividades,
                        recursos_educativos: recursos_educativos.map((re) => ({
                            id: re.id,
                            descripcion: re.descripcion,
                        })),
                    }),
                )
            } else {
                formData.append('payload', null)
            }
            if (typeof tickeo === 'boolean') formData.append('tickeo', tickeo)
            if (file) formData.append('file', file)

            const { success, message, ...res } = await APISERVICE.postWithImage(url, '', formData)
            if (success) {
                endClassInfo = {
                    horarioId: scheduleStorage.schedule.id,
                    verificaciones: res.verificaciones,
                }
                toast.success(message)
            } else {
                toast.error(message)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
        return endClassInfo
    }

    const sendJustification = async ({ descripcion, file, verificaciones }) => {
        let isSuccess = false
        try {
            setLoading(true)
            const formData = new FormData()
            const url = 'verificacion/justify'
            formData.append('descripcion', descripcion)
            formData.append('verificaciones', verificaciones)
            if (file) formData.append('file', file)

            const { success, message } = await APISERVICE.postWithImage(url, '', formData)
            if (success) {
                isSuccess = true
                toast.success(message)
            } else {
                toast.error(message)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
        return isSuccess
    }

    return { sendTicket, loading, sendEndClass, sendJustification }
}
